var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero'),_c('Why'),_c('FeaturedMovies'),_c('FeaturedTVShows'),_c('BlogSection'),_c('CityDorms'),_c('Media')],1)}
var staticRenderFns = []

export { render, staticRenderFns }